import { atom } from 'recoil';
import { IFaixaSalarial } from '../../../commons/types/config';

export const faixaSalarialAtom = atom<IFaixaSalarial[]>({
  key: 'faixaSalarial',
  default: [] as IFaixaSalarial[],
});
